module.exports = __webpack_public_path__ + "static/media/11.bf61054d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/11.png
// module id = 490
// module chunks = 0